import moment from "moment";
import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import TeacherEvents from "./EventCard";

const localizer = momentLocalizer(moment);

const events = [
  {
    id: 1,
    subject: "Math",
    start: new Date(2024, 8, 19, 9, 0), // Monday, 9:00 AM
    end: new Date(2024, 8, 19, 10, 0), // Monday, 10:00 AM
    class: "8th Grade",
    section: "A",
    teacherName: "Mr. John Doe",
    color: "#92f590",
  },
  {
    id: 2,
    subject: "English",
    start: new Date(2024, 8, 20, 11, 0), // Tuesday, 11:00 AM
    end: new Date(2024, 8, 20, 12, 0), // Tuesday, 12:00 PM
    class: "9th Grade",
    section: "B",
    teacherName: "Ms. Jane Smith",
    color: "#fcd7fc",
  },
  {
    id: 3,
    subject: "Science",
    start: new Date(2024, 8, 19, 10, 0), // Monday, 10:00 AM
    end: new Date(2024, 8, 19, 11, 0), // Monday, 11:00 AM
    class: "7th Grade",
    section: "A",
    teacherName: "Mr. David Lee",
    color: "#c9e3ff",
  },
  {
    id: 4,
    subject: "History",
    start: new Date(2024, 8, 21, 8, 0), // Wednesday, 12:00 PM
    end: new Date(2024, 8, 21, 9, 0), // Wednesday, 1:00 PM
    class: "10th Grade",
    section: "C",
    teacherName: "Ms. Emily Clark",
    color: "#f3a683",
  },
  {
    id: 5,
    subject: "Geography",
    start: new Date(2024, 8, 22, 9, 0), // Thursday, 9:00 AM
    end: new Date(2024, 8, 22, 10, 0), // Thursday, 10:00 AM
    class: "6th Grade",
    section: "B",
    teacherName: "Mr. Alex Turner",
    color: "#f7d794",
  },
  {
    id: 6,
    subject: "Physics",
    start: new Date(2024, 8, 23, 11, 0), // Friday, 11:00 AM
    end: new Date(2024, 8, 23, 12, 0), // Friday, 12:00 PM
    class: "9th Grade",
    section: "A",
    teacherName: "Ms. Sophia Brown",
    color: "#78e08f",
  },
  {
    id: 7,
    subject: "Chemistry",
    start: new Date(2024, 8, 19, 1, 0), // Monday, 1:00 PM
    end: new Date(2024, 8, 19, 2, 0), // Monday, 2:00 PM
    class: "11th Grade",
    section: "D",
    teacherName: "Mr. Michael King",
    color: "#fad390",
  },
  {
    id: 8,
    subject: "Biology",
    start: new Date(2024, 8, 24, 10, 0), // Saturday, 10:00 AM
    end: new Date(2024, 8, 24, 11, 0), // Saturday, 11:00 AM
    class: "8th Grade",
    section: "A",
    teacherName: "Ms. Rachel Adams",
    color: "#f8c291",
  },
  {
    id: 9,
    subject: "Computer Science",
    start: new Date(2024, 8, 25, 9, 0), // Sunday, 9:00 AM
    end: new Date(2024, 8, 25, 10, 0), // Sunday, 10:00 AM
    class: "12th Grade",
    section: "B",
    teacherName: "Mr. Steven Rogers",
    color: "#e77f67",
  },
];


const TimeTableCalendar = ({ handleSelectEvent }) => {
  const [currentEvents, setCurrentEvents] = useState(events);

  const eventStyleGetter = (event) => {
    let style = {
      borderRadius: "5px",
      color: "#000",
      display: "block",
      border: `2px solid ${event.color}`,
      backgroundColor: event.color,
    };

    return {
      className: "custom-event",
      style: style,
      title: "", // Disable default tooltip
    };
  };

  const formats = {
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "h:mm a", culture).replace(" ", "\n"),
    dayHeaderFormat: (date, culture, localizer) =>
      localizer.format(date, "dddd, MMMM DD, YYYY", culture),
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={currentEvents}
        startAccessor="start"
        endAccessor="end"
        selectable
        onSelectEvent={handleSelectEvent}
        defaultView="week"
        views={["week"]}
        formats={formats}
        tooltipAccessor={() => null}
        step={15}
        timeslots={2}
        components={{
          event: TeacherEvents,
        }}
        eventPropGetter={eventStyleGetter}
        style={{ height: "100vh" }}
      />
    </div>
  );
};

export default TimeTableCalendar;
